import ThankYouPage from '../../components/Pages/ThankYouPage/ThankYouPage';
import { pages } from '../pageTypes';
import PageWrapper from './PageWrapper';
import { useLocation } from '@reach/router';

export default function ThankYouPageWrapper() {
  const shouldBePage = pages.thankYou;
  const conditionTypes = {
    page: true,
  };
  const location = useLocation();
  const { status } = location.state || {};

  return (
    <PageWrapper
      pageToLoad={<ThankYouPage status={status}/>}
      shouldBePage={shouldBePage}
      conditions={conditionTypes}
    />
  );
}
